// extracted by mini-css-extract-plugin
export var assigneeBadge = "_l7-0";
export var assigneeDetails = "_l7-1";
export var assigneeInfo = "_l7-2";
export var dropdownContainer = "_l7-4";
export var dropdownImage = "_l7-5";
export var editAssigneeInfo = "_l7-3";
export var editAssigneeModalContainer = "_l7-6";
export var hidden = "_l7-8";
export var input = "_l7-7";